<template>
  <v-dialog persistent v-model="enrollStdDialog" max-width="70rem">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title> Student Enrollment </v-toolbar-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-switch
                :disabled="oneToOneClass"
                class="mt-4 pa-2"
                v-model="deEnrollMode"
                @change="changeEnrollMode()"
                label=""
              ></v-switch>
            </div>
          </template>
          <span>Remove Enrollment</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-icon v-if="!deEnrollMode" @click="openCloseSearchPanel()"
          >mdi-magnify</v-icon
        >
        <v-text-field
          v-if="deEnrollMode"
          v-model="searchStudent"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-container fluid v-model="panel" v-if="!deEnrollMode">
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-text-field
                v-model="studentFilter.mobileNo"
                label="Mobile No"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="studentFilter.email"
                label="Email"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                v-model="selectedInstitute"
                :items="institute"
                label="Institute Name"
                item-text="instituteName"
                item-value="instituteId"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="studentFilter.firstName"
                label="First Name"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="studentFilter.lastName"
                label="Last Name"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col class="mt-1">
              <v-combobox
                v-model="studentFilter.grade"
                :items="gradesArray"
                label="Grades"
                dense
                deletable-chips
                chips
                item-text="desc"
                item-value="id"
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="searchStudents()">Apply</v-btn>
          </v-row>
        </v-form>
      </v-container>

      <v-container fluid style="max-height: 22rem; overflow-y: auto">
        <v-data-table
          v-if="studentsList.length > 0"
          v-model="selectedStudents"
          :headers="studentHeadersForEnroll"
          :items="studentsList"
          :hide-default-footer="studentsList.length <= 10"
          show-select
          item-key="studentId"
          item-value="studentId"
          :search="searchStudent"
          @toggle-select-all="selectAllStudents"
          @contextmenu:row="rightClickHandler"
        >
          <template v-slot:[`item.email`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  item.email
                    ? item.email.length > 20
                      ? item.email.substring(0, 20) + "..."
                      : item.email
                    : "---"
                }}</span>
              </template>
              <span>{{ item.email ? item.email : "---" }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-row justify="center">
              <v-col>
                <v-chip
                  small
                  :color="
                    item.status == 'ACTIVE' ? 'success-chip' : 'error-chip'
                  "
                >
                  {{ item.status }}
                </v-chip>
              </v-col>
              <v-col>
                <v-icon v-if="!deEnrollMode && item.isEnrolled" color="primary"
                  >mdi-account-check</v-icon
                >
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.createdOn`]="{ item }">
            {{ formatDateTime(item.createdOn) }}
          </template>
          <template
            v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
          >
            <v-simple-checkbox
              :value="isSelected"
              :disabled="
                item.status != 'ACTIVE' || (!deEnrollMode && item.isEnrolled)
              "
              @input="select($event)"
            ></v-simple-checkbox>
          </template>
        </v-data-table>
        <CustomDataTable
          v-else
          :headers="studentHeadersForEnroll"
          :items="studentsList"
          :hide-default-footer="studentsList.length <= 10"
        />
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeEnrollDialog()">Cancel</v-btn>
        <v-btn
          v-if="!deEnrollMode"
          :disabled="selectedStudents.length == 0"
          color="primary"
          text
          @click="selectStudents()"
          >Enroll</v-btn
        >
        <v-btn
          v-if="deEnrollMode"
          :disabled="selectedStudents.length == 0 || oneToOneClass"
          color="primary"
          text
          @click="enrollDeEnrollStudents('UnAssign')"
          >Remove</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  BASE_URL,
  CLASSROOM_ASSIGN_STUDENTS,
  CLASSROOM_UN_ASSIGN_STUDENTS,
  SEARCH_STUDENT,
  GET_ALL_INSTITUTES,
} from "@/common/apiEndpoints";
import { SET_API_SUCCESS, SET_OVERLAY_VALUE } from "@/store/mutations";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import {
  getAxiosOptions,
  formatDateTime,
  rightClickHandler,
} from "@/common/utility";
import { GET_TOKEN } from "@/store/getters";
import { grades } from "@/common/constants";
import { studentHeadersForEnroll } from "@/common/tableHeadersData";
import CustomDataTable from "../CustomDataTable.vue";

export default {
  components: {
    CustomDataTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enrollStdDialog: false,
      searchStudent: "",
      deEnrollMode: false,
      selectedStudents: [],
      selectedInstitute: "",
      studentsList: [],
      studentFilter: {},
      institute: [],
      gradesArray: grades,
      studentHeadersForEnroll: studentHeadersForEnroll,
      panel: [],
      disabledCount: 0,
      editedClassRoom: {
        classRoomId: "",
        courseId: "",
        students: [],
      },
      oneToOneClass: false,
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  methods: {
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),

    formatDateTime(date) {
      return formatDateTime(date);
    },

    rightClickHandler(e, item) {
      return rightClickHandler(e, item);
    },

    openEnrollDialog(item, oneToOneClass = false) {
      this.enrollStdDialog = true;
      this.studentFilter.studentIds = item.students;
      this.editedClassRoom.classRoomId = item.classRoomId;
      this.editedClassRoom.courseId = item.courseId;
      this.editedClassRoom.students = item.students;
      this.getAllInstitutes();
      this.oneToOneClass = oneToOneClass;
      if (this.oneToOneClass) {
        this.deEnrollMode = true;
        this.changeEnrollMode();
      }
      this.panel = [0];
    },

    closeEnrollDialog() {
      this.deEnrollMode = false;
      this.selectedStudents = [];
      this.studentsList = [];
      this.studentFilter = {};
      this.selectedInstitute = "";
      this.enrollStdDialog = false;
      this.panel = [];
    },

    selectStudents() {
      this.editedClassRoom.students = this.selectedStudents.map((std) => {
        return std.studentId;
      });
      this.enrollDeEnrollStudents("Assign");
    },

    changeEnrollMode() {
      this.selectedStudents = [];
      this.studentsList = [];
      this.searchStudents();
    },

    enrollDeEnrollStudents(action) {
      let url = "";
      if (action == "Assign") url = CLASSROOM_ASSIGN_STUDENTS;
      else if (action == "UnAssign") {
        url = CLASSROOM_UN_ASSIGN_STUDENTS;
      }
      let payload = {};
      payload.classRoomId = this.editedClassRoom.classRoomId;
      payload.students = this.selectedStudents.map((std) => {
        return std.studentId;
      });
      this.setOverlayValue(true);
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          if (action == "Assign")
            this.setApiSuccess("Students Assigned Succesfully");
          else if (action == "UnAssign") {
            this.setApiSuccess("Students Un-Assigned Succesfully");
          }
          this.closeEnrollDialog();
          this.setOverlayValue(false);
          this.$emit("student-enrollment-updated", res.data);
        })
        .catch((error) => {
          error = error.errorMessage;
          this.closeEnrollDialog();
          this.setOverlayValue(false);
        });
    },

    searchStudents() {
      const payload = {};
      let flag = false;
      if (
        this.deEnrollMode &&
        this.studentFilter.studentIds &&
        this.studentFilter.studentIds.length > 0
      ) {
        payload.studentIds = this.studentFilter.studentIds;
        this.panel = [];
        flag = true;
      }
      if (this.studentFilter.mobileNo) {
        payload.mobileNo = this.studentFilter.mobileNo.trim();
        flag = true;
      }
      if (this.studentFilter.email) {
        payload.email = this.studentFilter.email.trim();
        flag = true;
      }
      if (this.studentFilter.firstName) {
        payload.firstName = this.studentFilter.firstName.trim();
        flag = true;
      }
      if (this.studentFilter.lastName) {
        payload.lastName = this.studentFilter.lastName.trim();
        flag = true;
      }
      if (this.selectedInstitute) {
        payload.instituteId = this.selectedInstitute;
        flag = true;
      }
      if (this.studentFilter.grade) {
        payload.grade = this.studentFilter.grade;
        flag = true;
      }
      let url = SEARCH_STUDENT;
      if (flag) {
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.studentsList = res.data.students;
            const self = this;
            self.disabledCount = 0;
            if (!this.deEnrollMode) {
              this.studentsList.map((item) => {
                if (item.status != "ACTIVE") {
                  self.disabledCount += 1;
                }
                if (
                  this.studentFilter.studentIds.includes(item.studentId) ||
                  item.enrolledCourses.includes(this.editedClassRoom.courseId)
                ) {
                  item.isEnrolled = true;
                  self.disabledCount += 1;
                } else {
                  item.isEnrolled = false;
                }
              });
            }
          })
          .catch((error) => {
            error = error.errorMessage;
            console.log(error);
          });
      }
      if (!this.deEnrollMode) {
        this.panel = [0];
      }
    },

    getAllInstitutes() {
      let url = GET_ALL_INSTITUTES;
      this.setOverlayValue(true);
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.institute = res.data.institutes;
          this.setOverlayValue(false);
        })
        .catch((error) => {
          error = error.errorMessage;
          this.setOverlayValue(false);
        });
    },

    openCloseSearchPanel() {
      this.panel.length == 0 ? (this.panel = [0]) : (this.panel = []);
    },

    selectAllStudents(props) {
      if (
        this.selectedStudents.length !=
        this.studentsList.length - this.disabledCount
      ) {
        this.selectedStudents = [];
        const self = this;
        props.items.forEach((item) => {
          if (item.status == "ACTIVE" && !item.isEnrolled) {
            self.selectedStudents.push(item);
          }
        });
      } else this.selectedStudents = [];
    },
  },
};
</script>

